define([
	"dojo/_base/declare",
	"csi/breadcrumb/StateActionController",
	"csi/locale",
	"./PriceListActionMixin"
], function(declare,StateActionController,locale,PriceListActionMixin) {

	return declare([StateActionController, PriceListActionMixin], {

		m_operation: "RevisePriceList",

		getMessage: function() {
			return locale.resource("RevisingPriceList");
		},

		getSuccess: function() {
			// see if we were passing UnfreezePrices = true in the request
			return locale.resource(this._bUnfreezePrices ? "RevisePriceListUnfreezePrices" : "RevisePriceListLeavePricesFrozen");
		}
	});
});
